import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, inject, onMounted, ref, watch } from 'vue'
import { LocationListProps } from '@/features/general/LocationsList/model/LocationsList.types'
import ObjectsView from '@/pages/ObjectsView/ObjectsView.vue'
import { useStore } from 'vuex'
import { TreeList } from '@/widgets/MenuPanel/ui/TreeView/methods/TreeList'
import isAllowMenuChange from '@/shared/lib/isAllowMenuChange'
import { useRouter } from 'vue-router'
import { handleAgnksObjectSelect } from '@/pages/AGNKS/ObjectsViewAGNKS/model/handleAnksObjectSelect'

interface ObjectsViewProps extends LocationListProps {}

export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectsViewAGNKS',
  props: {
    locations: {},
    handleLocationClick: { type: Function },
    isLoading: { type: Boolean },
    notFoundDescription: {}
  },
  setup(__props: any) {

const appContext = inject<any>('appContext')

const props = __props

const store = useStore()
const router = useRouter()

const agnksObjects = computed(() => {
    console.log('agnksObjects computed')
    return store.state.AGNKSEntity.featureCollections.regions?.features.map(
        feature =>
            new TreeList(
                feature.properties.name,
                null,
                feature.geometry.coordinates,
                feature.id,
                null,
                null,
                feature.properties.address
            )
    )
})
const chosenRegionId = computed(
    () => store.state.view.regionsView.chosenRegion.id
)
const focusedRegionNumber = computed(() => store.state.focusedRegionNumber)
const isLoading = ref(false)

const loadObjects = async () => {
    isLoading.value = true
    await store.dispatch('AGNKSEntity/loadByRegion', {
        loadFn: appContext.loadSource,
        regionId: chosenRegionId.value || focusedRegionNumber.value,
    })
    isLoading.value = false
}

const setList = async () => {
    await loadObjects()
}

watch(focusedRegionNumber, async () => {
    console.log('chosenRegionId changed', appContext)
    await setList()
})
watch(chosenRegionId, async () => {
    console.log('chosenRegionId changed')
    await setList()
})

onMounted(async () => {
    await loadObjects()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ObjectsView, _normalizeProps(_guardReactiveProps({
                handleLocationClick: clickedObject =>
                    _unref(handleAgnksObjectSelect)(
                        clickedObject,
                        _unref(appContext),
                        _unref(store).dispatch
                    ),
                locations: agnksObjects.value,
                isLoading: isLoading.value,
            })), null, 16)
  ]))
}
}

})